import { GAME_EVENTS } from '@kulee/tga-constant'
import BaseModule from './BaseModule'
import logger from './logger'
import type { Context } from './types'

class PKGame extends BaseModule {
  constructor(context: Context) {
    super(context)

    this.context.pm.on(GAME_EVENTS.ON_RECEIVE_GAME_MESSAGE, ({ data }) => {
      this.context.sdk.onReceiveGameMessage(data)
    })

    this.context.pm.on(GAME_EVENTS.ON_PLAYER_EXIT, ({ data }) => {
      this.context.sdk.onPlayerExit(data)
    })
  }

  public sendMessage(message: string, exceptSelf = false) {
    logger.log(`send game message`, message)

    this.context.pm.emit(GAME_EVENTS.SEND_GAME_MESSAGE, {
      message,
      exceptSelf
    })
  }

  public gameFinish(winner?: string) {
    logger.log(`game finish`, winner)

    this.context.pm.emit(GAME_EVENTS.GAME_FINISH, winner)
  }
}

export default PKGame
